module.exports = __webpack_public_path__ + "img/ar_m_3.c70b509c.png";